import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './cartSlice';
import storage from 'redux-persist/lib/storage'; // Usa localStorage para guardar el estado
import { persistReducer, persistStore } from 'redux-persist';
import { combineReducers } from 'redux';
import '@fortawesome/fontawesome-free/css/all.min.css';


const persistConfig = {
  key: 'root',
  storage,
};

const rootReducer = combineReducers({
  cart: cartReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REGISTER'],
        ignoredPaths: ['register'], // Ignora la propiedad "register"
      },
    }),
});

export const persistor = persistStore(store);
export default store;
